// TestPage.jsx

import { useState } from 'react';
import AdminLoginTest from './AdminLoginTest';

function TestPage() {
  return (
    <div className="min-h-screen bg-gray-100 py-10">
      <h1 className="text-3xl font-bold text-center mb-8">API Integration Test Page</h1>
      
      <div className="max-w-4xl mx-auto">
        <AdminLoginTest />
      </div>
    </div>
  );
}

export default TestPage;
